import { Text } from "@pentabd/ui";

import { Comment } from "@components/Comment";

import { useLanguage } from "@hooks/useLanguage";

import { getFilePreviewURL } from "@helpers/getFilePreviewURL";

import { UploadFileType } from "@type/HRM/upload-file";

export interface CommentType {
  comment: string;
  executioner: {
    nameEn: string;
    nameBn: string;
    fileId: string | null;
    documentId: string | null;
    [key: string]: any;
  };
  createdAt: string;
  document?: UploadFileType;
}

export const Comments = ({ data }: { data: CommentType[] }) => {
  const { language } = useLanguage();

  return (
    <>
      <Text
        weight="semibold"
        size="lg"
        color="dark"
        className="mb-8 pb-8 d-block border-bottom"
      >
        {language === "bn" ? "মন্তব্য" : "Comments"}
      </Text>
      {data && data.length ? (
        <div className="d-flex flex-column gap-10">
          {data.map(
            (
              { comment, executioner, createdAt, document }: CommentType,
              i: number,
            ) => {
              return (
                comment && (
                  <Comment
                    key={i}
                    name={
                      language === "bn"
                        ? executioner?.nameBn
                        : executioner?.nameEn
                    }
                    email={executioner?.email}
                    comment={comment}
                    document={document}
                    createdAt={createdAt}
                    imageURL={
                      executioner?.documentId && executioner?.fileId
                        ? getFilePreviewURL(
                            executioner?.documentId as string,
                            executioner?.fileId as string,
                          )
                        : undefined
                    }
                  />
                )
              );
            },
          )}
        </div>
      ) : (
        <Text color="title" weight="medium">
          {language === "bn" ? "এখনো কোন মন্তব্য নেই" : "No Comments Yet"}
        </Text>
      )}
    </>
  );
};
